// Masifi: i18n overlay (spec /root/docs/core-touchpoints-slim-design.md §4.1/§4.4). Upstream json files stay
// UNTOUCHED: our keys (additions) and improved translations (overrides) are merged on top at load time, and the word
// "Chatwoot" (brand token, same convention as upstream's replaceInstallationName) is replaced by the brand the
// backend delivers in window.globalConfig.INSTALLATION_NAME. Never a brand literal here.
const BRAND_TOKEN = /\bChatwoot\b/g;

const isObject = value =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

// The brand is chosen by an admin (reseller): strip HTML (some messages render with v-html) and escape vue-i18n
// syntax as literal interpolation, so "{", "@", "|"… cannot break message compilation. "%" too: vue-i18n reads "%{" as
// the legacy modulo placeholder and would swallow the "%" (review 11b A-M3).
export const safeBrand = brand =>
  String(brand)
    .replace(/[<>]/g, '')
    .replace(/[{}@$|%]/g, char => `{'${char}'}`);

export const deepMerge = (base, extra) => {
  if (!isObject(extra)) return base;
  const out = { ...base };
  Object.entries(extra).forEach(([key, value]) => {
    out[key] =
      isObject(value) && isObject(out[key])
        ? deepMerge(out[key], value)
        : value;
  });
  return out;
};

const rebrand = (node, brand) => {
  if (typeof node === 'string') return node.replace(BRAND_TOKEN, () => brand);
  if (Array.isArray(node)) return node.map(item => rebrand(item, brand));
  if (!isObject(node)) return node;
  return Object.fromEntries(
    Object.entries(node).map(([key, value]) => [key, rebrand(value, brand)])
  );
};

export const collectLeafPaths = (node, prefix = '') =>
  Object.entries(node).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    return isObject(value) ? collectLeafPaths(value, path) : [path];
  });

export const withMasifi = (
  messages,
  overlay = {},
  brand = typeof window !== 'undefined'
    ? window.globalConfig?.INSTALLATION_NAME
    : undefined
) =>
  Object.fromEntries(
    Object.entries(messages).map(([locale, localeMessages]) => {
      const merged = deepMerge(
        deepMerge(localeMessages, overlay.additions?.[locale]),
        overlay.overrides?.[locale]
      );
      return [locale, brand ? rebrand(merged, safeBrand(brand)) : merged];
    })
  );
